import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';
import fetch from 'cross-fetch';
import { Configuration } from '../../config';
import { formatDateFriendly } from '../../common/services/builders';


function TWIJobsDescriptionListingFunction({settings}) { 


    const [showNonMemberModal, setNonMemberModal] = useState();
    const [showTrialExpiredModal, setTrialExpiredModal] = useState();
    const [showJobDescription, setJobDescription] = useState({});



    let pathName = window.location.pathname;

    let searchSlug = pathName.substring(pathName.lastIndexOf('/') +1 )

    const HtmlDisplay = (props) => {
        return (
            <div dangerouslySetInnerHTML={{__html: props.html}} />
          );
    }

    useEffect(() => {
        fetch(Configuration.rootUrl+'/api/delivery/projects/website/entries/search?accessToken=D8wMky9p2x41vFHrR8MVV3bOWg7UCpolPYQTVMzoySnGJTx5', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                pageIndex: 0,
                pageSize: 1,
                where: [
                    {
                        field: 'sys.versionStatus',
                        equalTo: 'published'
                    },
                    {
                        field: 'sys.contentTypeId',
                        equalTo: 'TWIJobs'
                    },
                    {
                        field: 'sys.slug',
                        equalTo: searchSlug
                    }

                ]
                })
            })
            .then(response => response.json())
            .then(data => 	{
                


                setJobDescription(data.items[0]);

                console.log(showJobDescription);

            })
            .catch(error => console.error(error));


    }, []);

    const isAuthUser = () => {}



    const isAuthJobDescription = () => {
        return (
            <div className='twi-jobs'> 
                <div className="row">
    
                <div className="column large-1">
                        <ul className="social-share__list social-share--vertical">
                            <li className="social-share__item">
                                <a className="social-share__link" href="https://www.facebook.com/sharer.php?u=http%3a%2f%2fpreview-twi.cloud.contensis.com%2ftwi-jobs%2ffind-your-job%2fasme-welder-iii">
                                <span className="visuallyhidden">Facebook</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-facebook">
                                        <use xlinkHref="#icon-facebook"></use>
                                    </svg>	
                                </a>
                            </li>
                            <li className="social-share__item">
                                <a className="social-share__link" href="https://twitter.com/intent/tweet?url=http%3a%2f%2fpreview-twi.cloud.contensis.com%2ftwi-jobs%2ffind-your-job%2fasme-welder-iii&amp;text=ASME+Welder+III+&amp;via=twi_ltd">
                                <span className="visuallyhidden">Twitter</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-x">
                                        <use xlinkHref="#icon-x"></use>
                                    </svg>	
                                </a>
                            </li>
                            <li className="social-share__item">
                                <a className="social-share__link" href="https://www.linkedin.com/shareArticle?url=http%3a%2f%2fpreview-twi.cloud.contensis.com%2ftwi-jobs%2ffind-your-job%2fasme-welder-iii&amp;title=ASME+Welder+III+">
                                <span className="visuallyhidden">LinkedIn</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-linkedin">
                                        <use xlinkHref="#icon-linkedin"></use>
                                    </svg>	
                                </a>
                            </li>
                            
                        </ul>
                        <div className="spacer--large"></div>
                    
                </div>
    
    
    
    
                <div className="column large-6">
    
                    <span className="date">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon"><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-clock"></use></svg>Posted: {formatDateFriendly(showJobDescription.datePosted)}
                    </span>

                    
                    <HtmlDisplay html={showJobDescription.jobDescription} />
    
                 </div> {/* column large-6  */}
    
                <div className="column large-offset-1 large-4"> 

                    <h1>&nbsp;</h1>

                </div>
    
                </div> 
            </div>
        );


    }

    const nonMemberModal = () => {
        return (
          <div role="dialog" aria-hidden="false" className="dialog" id="inline-modal-qP9jVToXCUw">
              <div className="dialog__window" id="dialog-window-qP9jVToXCUw" role="document">
                  <header role="banner">
                      <a href='/theweldinginstitute-jobs/jobs' id="close-modal-button-qP9jVToXCUw" aria-label="Close Dialog" className="btn btn--modal-back" >
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon"><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-close-white"></use></svg>
                          <span className="visuallyhidden">Close Dialog</span>
                      </a>
                  </header>
                  <div className="paywall-message" >
                    <p>Hi,<br /></p>

                    <p>This content is for Welding Institute Members only.</p>

                    <p>You can access this content via a 7-Day trial of the jobsite or apply for Welding Institute membership below.</p>

                    <a href="/theweldinginstitute-jobs/professional-member-login.aspx?ReturnURL=/theweldinginstitute-jobs/jobs.aspx#/" className='btn btn--modal dark-green'>Login (Welding Institute Members)</a>
                    <a href="/theweldinginstitute-jobs/free-trial-login.aspx?ReturnURL=/theweldinginstitute-jobs/jobs.aspx#/" className='btn btn--modal dark-green'>Login (Free Trial Members)</a>
                    <a href="https://theweldinginstitute.com/membership/join-us" className='btn btn--modal light-green' target='_blank'>Become a Member</a>
                    <a href="/theweldinginstitute-jobs/register-for-free-trial.aspx" className='btn btn--modal light-green'>Sign up for 7-Day Free Trial</a>
                    <p>Discount codes available for some locations. Please contact your TWI <a href='/contact/twi-addresses' target='_blank'>Regional Office.</a></p>


                  </div>
              </div>
              <div className="dialog__mask"></div>
          </div>
  
  
        )
  
  
    }



    const trialExpiredModal = () => {
        return (
          <div role="dialog" aria-hidden="false" className="dialog" id="inline-modal-qP9jVToXCUw">
              <div className="dialog__window" id="dialog-window-qP9jVToXCUw" role="document">
                  <header role="banner">
                      <a href='/theweldinginstitute-jobs/jobs' id="close-modal-button-qP9jVToXCUw" aria-label="Close Dialog" className="btn btn--modal-close" onClick={navigateToJobs}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon"><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-close-white"></use></svg>
                          <span className="visuallyhidden">Close Dialog</span>
                      </a>
                  </header>
                  <div className="paywall-message" >
                      <p>Hi,<br /></p>
  
                      <p>Your 7-Days Trial Membership has expired.</p>
  
                      <p>You can continue to access the Jobs website by becoming a member of The Welding Institute.</p>
  
                      <a href="https://theweldinginstitute.com/membership/join-us" className='btn btn--modal' target='_blank'>Become a Member</a>
  
                  </div>
              </div>
              <div className="dialog__mask"></div>
          </div>
  
  
        )
    } 


// if (settings && (!settings.isAuth && !settings.freeTrialExpired))
// {
//     nonMemberModal();
// }

// if (settings && settings.freeTrialExpired)
// {
//     trialExpiredModal()
// }

// if (settings && settings.isAuth) {
//     isAuthUser()
//     isAuthJobDescription()
// }



return (
        <div className='twi-jobs'> 


            {settings && settings.freeTrialExpired && trialExpiredModal()}
            {settings && settings.isAuth && isAuthJobDescription()}
            {settings && !settings.isAuth && nonMemberModal()}

        </div>
	);
}


TWIJobsDescriptionListingFunction.propTypes = {
    entries: PropTypes.object,
};

const mapStateToProps = state => (
    { 
        entries: getEntries(state), 
        search: getSearch(state), 
        filters: getFilters(state), 
        settings: getSettings(state) 
    });

export default connect(mapStateToProps)(TWIJobsDescriptionListingFunction);

